import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import IconPlay from '@/components/UI/svg/blade/treaser/Play';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { detailYoutubeMap } from '@/constants/blade';

export default function First() {
    const { gtm } = useGlobal();
    const { t } = useLang('bladeroboticlawnmower');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        const isBird = !!document.querySelector('.crowdfunding-tabs-nav');
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow BLADE Robotic Lawn Mower | Let it Mow',
            position: isBird ? 'Product_1' : 'Product Detail_1',
        });
    };

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.ani-box', { y: 0 }, { y: 300 }]],
            triggerElement: '.ani-box',
            triggerHook: 0,
            offset: -50,
            duration: '50%',
        });
        AniContainer.create({
            syncFromTo: [['.mask', { y: 0 }, { y: -280 }]],
            triggerElement: '.content-box',
            triggerHook: 0,
            offset: 0,
            duration: '20%',
        });
    }, []);
    return (
        <div className={css['blade-treaser-detailA']}>
            <div className="content-img">
                <div className="video-box">
                    <EFVideo
                        autoPlay
                        loop={false}
                        className="video"
                        sources={['/video/blade/detail/pc/first_01.webm', '/video/blade/detail/pc/first_01.mp4']}
                    />
                </div>
            </div>
            <div className="content-box">
                <div className="ani-box">
                    <div>
                        <p className="title">{t('detail.sec1_title')}</p>
                    </div>
                    <div>
                        <p className="desc">{t('detail.sec1_desc')}</p>
                    </div>
                    <div>
                        <a className="btn-play" onClick={() => playerVideo()}>
                            {t('detail.sec1_video')}
                            <IconPlay className="icon-play" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="mask"></div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={detailYoutubeMap[locale] || detailYoutubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
